import * as tslib_1 from "tslib";
import { ApiClient, UiApiClient } from './ApiClient';
import { GetToken } from './commands/getToken';
import { accounts } from './commands/account';
import { GetAvailableFunds, GetBalances, GetBalancesForAccounts, GetBalancesForWithdrawal, } from './commands/getBalances';
import { GetBars } from './commands/getBars';
import { GetMarketSchedule } from './commands/marketSchedule';
import { quotes } from './commands/quote';
import { GetSymbols, Symbols } from './commands/symbols';
import * as positions from './commands/positions';
import { options } from './commands/options';
import { history } from './commands/history';
import { ACH, Transfers, cashieringSearch, cashieringDetails, SecurityQuestion, cashieringDocuments, TransferInstructions, cashieringProfile, } from './commands/cashiering';
import { pnlHistory } from './commands/getPnLItem';
import { order } from './commands/orderApi';
import { Application } from './commands/application';
import { UserCommands } from './commands/userCommands';
import { auth } from './commands/auth';
import { info } from './commands/information';
import { AccManagement } from './commands/accountManagement';
import { Entitlements } from './commands/entitlements';
import { Downloads } from './commands/downloads';
import { GetBalanceHistory, HistoryGetBalances } from './commands/historyGetBalance';
import { nopass } from './commands/nopass';
import { subaccounts } from './commands/subaccounts';
export class TradingBlockAccountApi {
    constructor(api, accountId, subaccountId) {
        this.order = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return order(this.api)(this.accountId, this.subaccountId); });
        this.availableFunds = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return GetAvailableFunds(this.api)(this.accountId, this.subaccountId); });
        this.balances = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return GetBalances(this.api)(this.accountId, this.subaccountId); });
        this.positions = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield positions.get(this.api)(this.accountId, this.subaccountId); });
        this.history = (request) => tslib_1.__awaiter(this, void 0, void 0, function* () { return history.get(this.api)(Object.assign({}, request, { accountId: this.accountId })); });
        this.pnl = (request) => tslib_1.__awaiter(this, void 0, void 0, function* () { return pnlHistory.get(this.api)(Object.assign({}, request, { accountId: this.accountId })); });
        this.availableWithdrawalFunds = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return GetBalancesForWithdrawal(this.api)(this.accountId); });
        this.accountId = accountId;
        this.subaccountId = subaccountId;
        this.api = api;
    }
}
export function TradingBlockApi(api) {
    return {
        auth: auth(api),
        accounts: accounts(api),
        accountManagement: AccManagement(api),
        balances: {
            get: GetBalances(api),
            getForAccounts: GetBalancesForAccounts(api),
            getForWithdrawals: GetBalancesForWithdrawal(api),
        },
        client: api,
        application: Application(api),
        getToken: GetToken(api),
        getBars: GetBars(api),
        getMarketSchedule: GetMarketSchedule(api),
        getSymbols: GetSymbols(api),
        cashiering: {
            ach: ACH(api),
            balances: GetBalances(api),
            securityQuestion: SecurityQuestion(api),
            transfers: Transfers(api),
            transferInstructions: TransferInstructions(api),
            search: cashieringSearch(api).search,
            details: cashieringDetails(api),
            documents: cashieringDocuments(api),
            profile: cashieringProfile(api),
        },
        history: {
            getBalanceHistory: GetBalanceHistory(api),
            getBalances: HistoryGetBalances(api),
        },
        downloads: Downloads(api),
        entitlements: Entitlements(api),
        information: info(api),
        nopass: nopass(api),
        order: order(api),
        options: options(api),
        quotes: quotes(api),
        symbols: Symbols(api),
        user: UserCommands(api),
        subaccounts: subaccounts(api),
    };
}
const tradingblockApis = {};
export function ApiFactory(rootUrl, authKey, onResponse, onResponseError) {
    if (tradingblockApis[rootUrl + authKey] !== undefined) {
        return tradingblockApis[rootUrl + authKey];
    }
    const tb_api = TradingBlockApi(new ApiClient(rootUrl, authKey).withResponseHandler({ onResponse, onResponseError }));
    tradingblockApis[rootUrl + authKey] = tb_api;
    return tb_api;
}
export function AccountApiFactory(rootUrl, authKey, accountId, subaccountId) {
    return new TradingBlockAccountApi(new ApiClient(rootUrl, authKey), accountId, subaccountId);
}
export function UiApiFactory(rootUrl, authKey) {
    return new UiApiClient(rootUrl, authKey);
}
//# sourceMappingURL=TradingBlockApi.js.map